import './gffStyles.css'

import * as farmActions from './farmActions'
import * as fieldActions from './fieldActions'
import * as growerActions from './growerActions'
import * as scoutActions from '../scoutManager/scoutActions'

import { Button } from '@atd/rui-base.mui.button'
import { FormControl } from '@atd/rui-base.mui.form-control'
import { IconButton } from '@atd/rui-base.mui.icon-button'
import { InputLabel } from '@atd/rui-base.mui.input-label'
import { MenuItem } from '@atd/rui-base.mui.menu-item'
import { Select } from '@atd/rui-base.mui.select'

import AddIcon from '@mui/icons-material/AddBox'
import ClearIcon from '@mui/icons-material/Cancel'
import FarmEdit from './farmedit'
import FieldEdit from './fieldedit'
import GrowerEdit from './groweredit'
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { farmPrototype } from './farmDataPrototype'
import { fieldPrototype } from './fieldDataPrototype'
import { growerPrototype } from './growerDataPrototype'

function mapStateToProps(state, ownProps) {
    return {
        growers: state.gff.growers,
        farms: state.gff.farms,
        fields: state.gff.fields,

        selectedGrower: state.gff.selectedGrower,
        selectedFarm: state.gff.selectedFarm,
        selectedField: state.gff.selectedField,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(growerActions, dispatch),
        ...bindActionCreators(farmActions, dispatch),
        ...bindActionCreators(fieldActions, dispatch),
        ...bindActionCreators(scoutActions, dispatch),
    }
}

class GrowerFarmField extends React.Component {
    state = {
        addState: '',
        tempGffItem: {},
    }

    componentDidMount() {
        this.props.fetchGrowers()
        this.props.fetchFarms()
        this.props.fetchFields()
    }

    selectGrower = (event, index, value) => {
        if (value !== -1) {
            this.props.selectGrower(
                this.props.growers.find(element => {
                    return element.id === value
                }),
            )
            const gFarms = this.props.farms.filter(farm => farm.growerId === value)
            if (gFarms.length === 1) {
                this.selectFarm({}, 1, gFarms[0].id)
            }
            else {
                this.props.selectFarm()
                this.props.selectField()
            }
        }
        else { this.addGrower() }
    }
    clearGrower = () => {
        this.props.selectGrower()
        this.props.selectFarm()
        this.props.selectField()
    }
    createGrowerDropDownList = () => {
        const addButton = (
            <MenuItem value={-1} key={'new'} name="addGrower">
                <Button variant="contained"
                    color="primary"
                    fullWidth
                    onClick={this.addGrower}
                    name="newGrowerButton">
                    <AddIcon />
                </Button>
            </MenuItem>
        )

        return [addButton, ...this.props.growers.map(this.gffToMenuItem)]
    }
    addGrower = () => {
        this.setState({
            addState: 'grower',
            tempGffItem: new growerPrototype(''),
        })
    }
    saveGrower = newData => {
        this.props.addGrower(newData)
        this.setState({ addState: '', tempGffItem: {} })
        this.props.selectFarm()
        this.props.selectField()
    }

    selectFarm = (event, index, value) => {
        if (value !== -1) {
            this.props.selectFarm(
                this.props.farms.find(element => {
                    return element.id === value
                }),
            )
            const gFields = this.props.fields.filter(field => field.farmId === value)
            if (gFields.length === 1) {
                this.selectField({}, 1, gFields[0].id)
            }
            else {
                this.props.selectField()
            }
        }
        else { this.addFarm() }
    }
    clearFarm = () => {
        this.props.selectFarm()
        this.props.selectField()
    }
    createFarmDropDownList = () => {
        const addButton = (
            <MenuItem value={-1} key={'new'} name="newFarm">
                <Button variant="contained"
                    color="primary"
                    fullWidth
                    onClick={this.addFarm}
                    name="newFarmButton">
                    <AddIcon />
                </Button>
            </MenuItem>
        )
        const farms = this.props.farms.filter(farm => farm.growerId === this.props.selectedGrower.id)

        return [addButton, ...farms.map(this.gffToMenuItem)]
    }
    addFarm = () => {
        this.setState({
            addState: 'farm',
            tempGffItem: new farmPrototype(this.props.selectedGrower.id, ''),
        })
    }
    saveFarm = newData => {
        this.props.addFarm(newData)
        this.setState({ addState: '', tempGffItem: {} })
        this.props.selectField()
    }

    selectField = (event, index, value) => {
        if (value !== -1) {
            const fieldAction = this.props.selectField(
                this.props.fields.find(element => {
                    return element.id === value
                }),
            )
            this.props.selectCentroid(fieldAction.field.center)
            this.props.setEntrancePoints(fieldAction.field.entrances)
            this.props.setBoundaryGeoJson(fieldAction.field.boundaries)
            this.props.setBoundaryPoints(fieldAction.field.boundaries)
            this.props.setFieldDisplayArea(fieldAction.field.displayArea)
            this.props.setFieldAreaDisplayUnit(fieldAction.field.areaDisplayUnit)
        }
        else { this.addField() }
    }
    clearField = () => {
        this.props.selectField()
    }

    createFieldDropDownList = () => {
        const addButton = (
            <MenuItem value={-1} key={'new'} name="addField">
                <Button variant="contained"
                    color="primary"
                    fullWidth
                    onClick={this.addField}
                    name="newFieldButton">
                    <AddIcon />
                </Button>
            </MenuItem>
        )
        const fields = this.props.fields.filter(field => field.farmId === this.props.selectedFarm.id)

        return [addButton, ...fields.map(this.gffToMenuItem)]
    }
    addField = () => {
        this.setState({
            addState: 'field',
            tempGffItem: new fieldPrototype(this.props.selectedGrower.id, this.props.selectedFarm.id, ''),
        })
    }
    saveField = newData => {
        this.props.addField(newData)
        this.setState({ addState: '', tempGffItem: {} })
    }

    gffToMenuItem = (data, i) => {
        return <MenuItem key={data.id} value={data.id} name={data.id}>{data.name}</MenuItem>
    }
    cancelAdd = () => {
        this.setState({ addState: '', tempGffItem: {} })
    }


    renderGrowerSection = () => {
        const availGrowers = this.createGrowerDropDownList()
        let growerClearButton = null
        if (!this.props.disabled) {
            growerClearButton = (
                <IconButton disabled={this.props.selectedGrower.id < 0}
                    className="clearSelection"
                    name="clearGrower"
                    onClick={this.clearGrower}>
                    <ClearIcon/>
                </IconButton>
            )
        }

        return (
            <div style={{display: 'flex', marginBottom: '16px'}}>
                <FormControl variant="standard" disabled={this.props.disabled} className="gffSelect">
                    <InputLabel>Grower</InputLabel>
                    <Select
                        value={this.props.selectedGrower.id < 0 ? '' : this.props.selectedGrower.id}
                        onChange={(event) => this.selectGrower(event, null, event.target.value)}
                        name="growerDropDown"
                        label="Grower"
                    >
                        {availGrowers}
                    </Select>
                </FormControl>
                {growerClearButton}
            </div>
        )
    }
    renderFarmSection = () => {
        const availFarms = this.createFarmDropDownList()
        let farmClearButton = null
        if (!this.props.disabled) {
            farmClearButton = (
                <IconButton disabled={this.props.selectedFarm.id < 0}
                    className="clearSelection"
                    name="clearFarm"
                    onClick={this.clearFarm}>
                    <ClearIcon/>
                </IconButton>
            )
        }

        return (
            <div style={{display: 'flex', marginBottom: '16px'}}>
                <FormControl variant="standard" disabled={this.props.selectedGrower.id === -1 || this.props.disabled} className="gffSelect">
                    <InputLabel>Farm</InputLabel>
                    <Select
                        value={this.props.selectedFarm.id < 0 ? '' : this.props.selectedFarm.id}
                        onChange={(event) => this.selectFarm(event, null, event.target.value)}
                        name="farmDropdown"
                        label="Farm"
                    >
                        {availFarms}
                    </Select>
                </FormControl>
                {farmClearButton}
            </div>
        )
    }
    renderFieldSection = () => {
        const availFields = this.createFieldDropDownList()
        let fieldClearButton = null
        if (!this.props.disabled) {
            fieldClearButton = (
                <IconButton disabled={this.props.selectedField.id < 0}
                    className="clearSelection"
                    name="clearField"
                    onClick={this.clearField}>
                    <ClearIcon/>
                </IconButton>
            )
        }

        return (
            <div style={{display: 'flex', marginBottom: '16px'}}>
                <FormControl variant="standard" disabled={this.props.selectedFarm.id === -1 || this.props.disabled} className="gffSelect">
                    <InputLabel>Field</InputLabel>
                    <Select
                        value={this.props.selectedField.id < 0 ? '' : this.props.selectedField.id}
                        onChange={(event) => this.selectField(event, null, event.target.value)}
                        name="fieldDropDown"
                        label="Field"
                    >
                        {availFields}
                    </Select>
                </FormControl>
                {fieldClearButton}
            </div>
        )
    }
    getAddDialog = () => {
        if (this.state.addState === 'grower') {
            return (
                <GrowerEdit
                    data={this.state.tempGffItem}
                    onCancel={this.cancelAdd}
                    onSubmit={this.saveGrower}
                    open={true}
                />
            )
        }
        else if (this.state.addState === 'farm') {
            return (
                <FarmEdit
                    data={this.state.tempGffItem}
                    onCancel={this.cancelAdd}
                    onSubmit={this.saveFarm}
                    open={true}
                />
            )
        }
        else if (this.state.addState === 'field') {
            return (
                <FieldEdit
                    data={this.state.tempGffItem}
                    onCancel={this.cancelAdd}
                    onSubmit={this.saveField}
                    open={true}
                />
            )
        }
    }
    render() {
        const growerSection = this.renderGrowerSection()
        const farmSection = this.renderFarmSection()
        const fieldSection = this.renderFieldSection()
        const addDialog = this.getAddDialog()

        return (
            <div className="sectionContainer">
                <div>If left empty none will be assumed.</div>
                {growerSection}
                {farmSection}
                {fieldSection}
                {addDialog}
            </div>
        )
    }
}

// be sure to connect the component to the Redux state so it can use it!
export default connect(mapStateToProps, mapDispatchToProps)(GrowerFarmField)
